import {SET_OPEN_STATE} from './types';
function actionSetOpenState(isOpen) {
    return {
        type: SET_OPEN_STATE,
        payload: isOpen
    };
}

export default actionSetOpenState;



// WEBPACK FOOTER //
// ./redux/actions/openState.js